/******************************************************************************
 *
 * ChecklistSection
 *
 * Displays runtime checklists of the selected Work Item.
 *
 ******************************************************************************/

import React, { useState } from "react";
import RuntimeChecklistItems from "./RuntimeChecklistItems";

export default function ChecklistSection({

    checklists = []

}) {

    const [

        expandedChecklist,

        setExpandedChecklist

    ] = useState(null);

    return (

        <div
            className="card border-0 shadow-sm mb-3"
            style={{
                borderRadius: "12px"
            }}
        >

            {/* Header */}

            <div
                className="card-header border-0 text-white py-2"
                style={{
                    background:
                        "linear-gradient(135deg,#2563EB,#1E40AF)",
                    borderTopLeftRadius: "12px",
                    borderTopRightRadius: "12px"
                }}
            >

                <div className="d-flex justify-content-between align-items-center">

                    <div className="fw-semibold">

                        📋 Runtime Checklists

                    </div>

                    <span className="badge bg-light text-dark">

                        {checklists.length}

                    </span>

                </div>

            </div>

            <div className="card-body p-3">

                {

                    checklists.length === 0

                        ?

                        (

                            <div className="text-center text-muted py-4">

                                No runtime checklist available.

                            </div>

                        )

                        :

                        checklists.map((checklist) => {

                            const expanded =
                                expandedChecklist === checklist.id;

                            const percentage =
                                checklist.execution_percentage || 0;

                            const status =
                                checklist.execution_status || "NOT_STARTED";

                            const statusColor = {

                                NOT_STARTED: "#6B7280",

                                IN_PROGRESS: "#2563EB",

                                COMPLETED: "#16A34A"

                            }[status] || "#6B7280";

                            return (

                                <div
                                    key={checklist.id}
                                    className="border rounded shadow-sm mb-3 overflow-hidden"
                                >

                                    {/* Summary */}

                                    <div

                                        className="px-3 py-3"

                                        style={{
                                            cursor: "pointer",
                                            background: "#F8FAFC"
                                        }}

                                        onClick={() =>

                                            setExpandedChecklist(

                                                expanded

                                                    ? null

                                                    : checklist.id

                                            )

                                        }

                                    >

                                        <div className="d-flex justify-content-between align-items-start">

                                            <div style={{ flex: 1 }}>

                                                <div className="fw-semibold">

                                                    {checklist.checklist_name}

                                                </div>

                                                <div className="text-muted small">

                                                    {checklist.checklist_code}

                                                </div>

                                            </div>

                                            <div className="text-end">

                                                <span

                                                    className="badge"

                                                    style={{
                                                        background: statusColor
                                                    }}

                                                >

                                                    {status}

                                                </span>

                                                <div

                                                    className="fw-bold mt-2"

                                                    style={{
                                                        color: "#2563EB"
                                                    }}

                                                >

                                                    {percentage}%

                                                </div>

                                            </div>

                                        </div>

                                        {/* Progress */}

                                        <div
                                            className="progress mt-3"
                                            style={{
                                                height: "8px",
                                                borderRadius: "10px"
                                            }}
                                        >

                                            <div

                                                className="progress-bar"

                                                style={{

                                                    width: `${percentage}%`,

                                                    background:

                                                        percentage === 100

                                                            ? "#16A34A"

                                                            : "#2563EB"

                                                }}

                                            />

                                        </div>

                                        <div className="text-end mt-2">

                                            <i

                                                className={
                                                    expanded

                                                        ? "bi bi-chevron-up"

                                                        : "bi bi-chevron-down"
                                                }

                                            />

                                        </div>

                                    </div>

                                    {/* Runtime Items */}

                                    {

                                        expanded && (

                                            <div className="border-top p-3 bg-white">

                                                <RuntimeChecklistItems

                                                    workChecklistId={checklist.id}

                                                />

                                            </div>

                                        )

                                    }

                                </div>

                            );

                        })

                }

            </div>

        </div>

    );

}